import { render, staticRenderFns } from "./MailboxReply.vue?vue&type=template&id=70f97cf4"
import script from "./MailboxReply.vue?vue&type=script&lang=js"
export * from "./MailboxReply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports